export const REQUEST_FILTERS = 'REQUEST_FILTERS';
export const RECEIVE_FILTERS = 'RECEIVE_FILTERS';
export const REPORT_FILTERS_REQUEST_ERROR = 'REPORT_FILTERS_REQUEST_ERROR';
export const SELECT_FILTER = 'SELECT_FILTER';
export const FILTER_DATA = 'FILTER_DATA';
export const SELECT_ALL_FILTERS = 'SELECT_ALL_FILTERS';
export const DESELECT_ALL_FILTERS = 'DESELECT_ALL_FILTERS';